import { Box, Container, Typography } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fafafa", py: 4 }}>
      <Container maxWidth="md">
        <Typography component="h1" variant="h4" fontWeight="bold" gutterBottom>
          Treasure Terms and Conditions
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Last updated: {new Date().toLocaleDateString("en-IN")}
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By downloading, installing, or using Treasure ("App") and related services, you agree to these Terms and Conditions. If you do not agree, do not use the App. The App is provided by Weps Technology.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Use of the Service
        </Typography>
        <Typography variant="body1" paragraph>
          You may use Treasure for personal or permitted business use to track income, expenses, and manage committees. You must provide accurate information and keep your account secure. You are responsible for all activity under your account.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Prohibited Conduct
        </Typography>
        <Typography variant="body1" paragraph>
          You must not: use the App for any illegal purpose; attempt to gain unauthorized access to our systems or other users' data; reverse-engineer or misuse the App; or use the App in a way that could harm, disable, or overburden our services.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Intellectual Property
        </Typography>
        <Typography variant="body1" paragraph>
          All rights in the App, including design, logos, and content (except user-generated content), belong to Weps Technology. You may not copy, modify, or distribute our intellectual property without written permission.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Disclaimers
        </Typography>
        <Typography variant="body1" paragraph>
          The App is provided "as is". We do not guarantee uninterrupted or error-free service. We are not responsible for decisions you make based on data or reports in the App. Use the App at your own risk.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          To the fullest extent permitted by law, Weps Technology shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the App. Our total liability shall not exceed the amount you paid to us in the past 12 months, if any.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Changes to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          We may update these Terms from time to time. We will notify you of material changes. Continued use of the App after changes constitutes acceptance of the updated Terms.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Governing Law
        </Typography>
        <Typography variant="body1" paragraph>
          These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts at Saharanpur, Uttar Pradesh, India.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3, mb: 1 }}>
          Contact
        </Typography>
        <Typography variant="body1" paragraph>
          For any queries regarding these Terms, please contact us using the contact details provided in the footer of this website.
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
